<template>
  <section class="home_page">
    <help-center-bar class="tab"></help-center-bar>
    <div class="container">
      <div class="helpCenter">
        <s-title-header mainTitle='帮助中心' subTitle="管理" description="帮您快速了解邀拍产品"></s-title-header>
        <s-button class="newbtn" v-if="$store.getters.roler==='admin'" @click.native="appear" width=0.68 height=0.2 lineHeight=0.2 color="#276BEE" ave="#fff" border='solid 1px #276BEE' textWord="创建产品" ></s-button>
      </div>
      <div class="content">
        <div class="pic" v-if="isShowPic"><img src="../assets/noData.png" alt=""></div>
        <production class="production" @appearPopup='popContent(item)' v-for="item in productList" :productStatus="item.Hidden" :productName='item.Name' :productDes='item.Description' :productId='item._id' :key='item._id'></production>
      </div>

    </div>
    <Popup
      v-if="isPopupShow"
      @changePopShow='isPopupShow = false'
      @successCallback='getData'
      :proName='itemName'
      :proDes ='itemDes'
      :proId ='itemId'
      :isPopupShow='isPopupShow'
      :proHidden='isHidden'
    >
    </Popup>
  </section>
</template>
<script>
import Api from '@/api/api'
import HelpCenterBar from '@/components/HelpCenterBar'
import Production from '@/components/Production'
import STitleHeader from '@/components/STitleHeader'
import SButton from '@/components/SButton'
import Popup from '@/components/Popup'
export default {
  /******************************************
  ** 组件名称
  * @description 组件描述
  * @author ah
  *****************************************
  prop1          <type>            <属性描述>
  *****************************************/
  name: 'component_name',
  components: {HelpCenterBar, Production, STitleHeader, SButton, Popup},
  props: {},
  data () {
    return {
      productList: [],
      isPopupShow: false, // 弹框
      itemName: '',
      itemDes: '',
      itemId: '',
      isShowPic: false,
      isHidden: false
    }
  },
  computed: {
    lisRule () {
      return this.$store.getters.roler
    }
  },
  watch: {
    lisRule: function (val) {
      // console.log('watch', val)
      // console.log(this)
      if (val === 'user') {
        this.getData(false)
      }
    }
  },
  mounted () {
    this.getRoler()
    this.scroll()
    // this.change()
  },
  methods: {
    scroll () {
      // 滑动到一定高度,固定tab栏
      $(window).scroll(function () {
        let scrollDistance = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        // console.log(scrollDistance)
        if (scrollDistance >= 0) {
          $('.tab').addClass('fixtab')
        } else {
          $('.tab').removeClass('fixtab')
        }
        if (scrollDistance >= 30) {
          $('.newbtn').addClass('fixbtn')
        } else {
          $('.newbtn').removeClass('fixbtn')
        }
      }
      )
    },
    // 点击创建产品按钮
    appear () {
      this.itemName = ''
      this.itemDes = ''
      this.isPopupShow = true
      this.isHidden = false
      // console.log(1111111)
    },
    // 获取用户角色,获取相应的数据
    getRoler () {
      Api.getProducts().then(res => {
        this.$store.dispatch('setRoler', res.data.role)

        if (this.$store.getters.roler === 'admin') {
          this.getData()
        } else {
          this.getData(false)
        }
      })
        .catch(err => {
          console.log(err)
        })
    },
    // 获取产品列表
    getData (val) {
      Api.getProducts(val).then(res => {
        // console.log(res)

        this.$store.dispatch('setRoler', res.data.role)
        if (this.productList.length === 0) {
          this.isShowPic = true
        }
        this.isShowPic = false
        this.productList = res.data.Result
      })
        .catch(err => {
          console.log(err)
        })
    },
    // 点击设置,显示弹框,并显示产品组件的信息
    popContent (item) {
      this.itemId = item._id
      this.itemName = item.Name
      this.itemDes = item.Description
      this.isHidden = item.Hidden
      this.isPopupShow = true
      // console.log(item)
      // console.log('father')
    }
  }
}
</script>
<style lang="less" scoped>
// @import '../style/common.less'
.home_page{
  width: 100%;
  .container{
    width: 88%;
    // width: 5.4rem;
    margin:0 auto;
    .helpCenter{
      // padding:80px 0;
      padding:0.4rem 0;
      // padding-top:0.6rem;
      width: 100%;
      height: auto;
      line-height: auto;
      display: flex;
      justify-content: space-between;
      // .fixbtn{
      //   position: fixed;
      //   top: 50px;
      //   left: 1355px;
      //   // margin-left: -520px;
      //   // padding-top: 30px;
      //   // margin-top:100px;
      //   background-color: #fff;
      //   z-index:999;
      //   // background-color: #F7F7F7;
      // }
    }
    // .fixbtn{
    //   position: fixed;
    //   top: 100px;
    //   left: 413px;
    //   // margin-left: -520px;
    //   // padding-top: 30px;
    //   // margin-top:100px;
    //   background-color: #fff;
    //   z-index:999;
    //   // background-color: #F7F7F7;
    // }
    // .newbtn{
    //   line-height:0.2rem;
    // }
    .content{
      width: 100%;
      margin:0 auto;
      display:flex;
      justify-content: space-around;
      flex-wrap: wrap;

      .pic {
        margin:1rem auto;
      }
    }
  }
  .fixtab{
    position: fixed;
    top: 0px;
    left: 0px;
    // margin-left: -520px;
    // padding-top: 30px;
    z-index:999;
    background-color: #F7F7F7;
  }
  .active1 {
    color:#fff;
    background-color: pink;
  }

}

</style>



// WEBPACK FOOTER //
// src/pages/Home.vue